<lib-filtered-table
  [tableId]="'on-hold'"
  [tableTitle]="'closed_requests_screen_tab_table_title' | transloco"
  [dataSource]="dataSource()"
  [meta]="meta()"
  [columns]="columns()"
  [isLoadingData]="isLoading()"
  [tableFilterTabs]="tableFilterTabs()"
  [(payload)]="payload"
  [tableColumnTemplates]="
    [
      { template: number, identifier: COLUMN_IDENTIFIERS.NUMBER },
      { template: id, identifier: COLUMN_IDENTIFIERS.ID },
      { template: name, identifier: COLUMN_IDENTIFIERS.NAME },
      { template: creation_date, identifier: COLUMN_IDENTIFIERS.CREATION_DATE },
      { template: creator, identifier: COLUMN_IDENTIFIERS.CREATOR },
      {
        template: remaining_time,
        identifier: COLUMN_IDENTIFIERS.REMAINING_TIME,
      },
      {
        template: request_subject,
        identifier: COLUMN_IDENTIFIERS.REQUEST_SUBJECT,
      },
      { template: project, identifier: COLUMN_IDENTIFIERS.PROJECT },
      { template: current_step, identifier: COLUMN_IDENTIFIERS.CURRENT_STEP },
      { template: assignees, identifier: COLUMN_IDENTIFIERS.ASSIGNEES },
      {
        template: related_requests,
        identifier: COLUMN_IDENTIFIERS.RELATED_REQUESTS,
      },
      { template: action, identifier: COLUMN_IDENTIFIERS.ACTION },
    ]
      | filterTableColByFeatFlag
        : showRelatedRequestsColumn()
        : COLUMN_IDENTIFIERS.RELATED_REQUESTS
  "
  [filterOptions]="filterOptions"
  [filterMapping]="filterMapping"
  [isTableExportable]="false"
  [searchPlaceholder]="'my_organization_screen_search_input_placeholder'"
  [applyOnStreamChanges]="checkReturnedObservable"
  (streamSucceeds)="handleOnHoldSuccess($event)"
  (handleApiCall)="handleApiCall()" />

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
  }
</ng-template>

<ng-template #id let-row>
  {{ row.request_id }}
</ng-template>

<ng-template #name let-row>
  {{ row.name }}
</ng-template>

<ng-template #creation_date let-row>
  <span dir="ltr">
    {{ row.created_at | date: 'dd-MMM-yyyy hh:mm a' }}
  </span>
</ng-template>

<ng-template #creator let-row>
  <lib-request-creator [creator]="row.creator" />
</ng-template>

<ng-template #remaining_time let-row>
  {{ row.remaining_sla }}
</ng-template>

<ng-template #request_subject let-row>
  <span
    class="request-subject-width"
    libTrimTooltip
    placement="top"
    [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top request-subject-tooltip'"
    [trimLength]="20"
    [fullText]="row.request_subject ?? ''">
  </span>
</ng-template>

<ng-template #project let-row>
  @if (row.project?.name) {
    <a
      [routerLink]="['/projects' | tenantPath, row.project.id]"
      class="flex items-center gap-md cursor-pointer text-neutral-900 hover:!underline hover:text-primary-500">
      <lib-avatar
        [size]="'list'"
        [img]="row.project?.image?.url"
        [fullName]="row.project?.name"
        borderRadius="rounded-full" />
      <span class="text-xs font-medium">
        {{ row.project?.name | truncate }}
      </span>
    </a>
  }
</ng-template>

<ng-template #current_step let-row>
  {{ row.current_position_name }}
</ng-template>

<ng-template #assignees let-row>
  @if (row.assignees?.length) {
    <lib-user-dropdown-view
      [showAssigneeName]="true"
      [userCount]="row.assignees.length"
      [userTableList]="row.assignees"
      [userDropdownList]="row.assignees"
      [totalDropdownCount]="row.assignees.length"
      [assigneeType]="row.assigneeType"
      [headerListLabel]="'dropdown_search_find_assignees_label' | transloco"
      [searchLabel]="'dropdown_search_find_assignees_label' | transloco"
      [searchPlaceholder]="'search_by_name_placeholder' | transloco"
      [noSearchResultLabel]="'no_search_result_label' | transloco"
      [enableLocalSearch]="true"
      [imgDimensions]="{ width: 1.5, height: 1.5 }"
      [containerRef]="'on_hold_requests'" />
  }
</ng-template>

<ng-template #related_requests let-row>
  <lib-related-requests-dropdown
    [childFlows]="row.child_flows"
    [viewDetailsRouterLink]="getRelatedRequestViewLink" />
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    [parentName]="'on-hold'"
    [menuItems]="row.actionList" />
</ng-template>
